module.exports = __webpack_public_path__ + "static/media/Cold.d4c701a4.png";